export default "__VITE_ASSET__CSAMPf35__"